export var MessageType;
(function (MessageType) {
    MessageType["Appointment"] = "appointment";
    MessageType["Code"] = "code";
    MessageType["File"] = "file";
    MessageType["Sketch"] = "sketch";
    MessageType["Text"] = "text";
    MessageType["Feedback"] = "feedback";
})(MessageType || (MessageType = {}));
//# sourceMappingURL=message.js.map